module.exports = __webpack_public_path__ + "static/tech-Icon-Inspiration-b36d0f452a87995cd53b0bb998d2ce0b.png";